document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); 

const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 
(function() {
  function redirectToLogin(e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = "/account/login";
  }

  document.addEventListener("click", function(event) {
    if (event.target.classList.contains("bss-lock-message")) {
      redirectToLogin(event);
    }
  }, true);

  const css = `
    .bss-lock-message {
      cursor: pointer !important;
    }
  `;
  
  if (document.head) {
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
  } else {
    document.addEventListener("DOMContentLoaded", function() {
      const style = document.createElement('style');
      style.innerHTML = css;
      document.head.appendChild(style);
    });
  }
})();

(function() {
  // ✅ NEW: Redirect if URL contains bss-redirect query param
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('bss-redirect')) {
    window.location.href = "https://shopify.com/97831092608/account/profile";
    return;
  }

  function redirectToLogin(e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = "/customer_authentication/login?return_to=/?bss-redirect";
  }

  document.addEventListener("click", function(event) {
    if (event.target.classList.contains("bss-lock-message")) {
      redirectToLogin(event);
    }
  }, true);

  const css = `
    .bss-lock-message {
      cursor: pointer !important;
    }
  `;

  if (document.head) {
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
  } else {
    document.addEventListener("DOMContentLoaded", function() {
      const style = document.createElement('style');
      style.innerHTML = css;
      document.head.appendChild(style);
    });
  }
})();